import { jsx as _jsx } from "react/jsx-runtime";
import { DayPicker, } from "react-day-picker";
import styles from "react-day-picker/dist/style.module.css";
import { Caption } from "./Caption";
import { Dropdown } from "./Dropdown";
import { CaptionLabel } from "./CaptionLabel";
import dayjs from "dayjs";
import { IconDropdown } from "./IconDropdown";
import { IconLeft } from "./IconLeft";
import { IconRight } from "./IconRight";
import { FOCUS_VISIBLE_OUTLINE } from "../../../utils/css-helpers";
export const Calendar = ({ onDayClick, onDayKeyDown, value }) => {
    const navButtonClasses = [
        "!border-0",
        "focus-visible:!outline-dashed",
        "focus-visible:!outline-general-yellow-primary",
        "dark:focus-visible:!outline-general-yellow-primary-darkmode",
        "hover:!outline",
        "hover:!outline-cta-primary-hover",
        "dark:hover:!outline-border-brand-darkmode",
        "!bg-transparent",
        "!p-1.5",
        "!mr-0.25",
    ];
    const classNames = Object.assign(Object.assign({}, styles), { cell: "p-0.25", day: [
            "!border-0",
            "bg-transparent",
            ...FOCUS_VISIBLE_OUTLINE,
            "focus-visible:!bg-transparent",
            "focus-visible:!text-text-primary",
            "dark:focus-visible:!text-text-primary-darkmode",
            "hover:!bg-cta-secondary-hover",
            "dark:hover:!bg-general-brand-tertiary-darkmode",
            "hover:!text-text-primary",
            "flex",
            "overflow-hidden",
            "items-center",
            "justify-center",
            "!rounded-[100%]",
            "w-[40px]",
            "min-w-[40px]",
            "h-[40px]",
        ].join(" "), day_today: [
            "!outline",
            "!outline-cta-primary-default",
            "dark:!outline-general-brand-primary-darkmode",
        ].join(" "), day_selected: [
            "!bg-cta-primary-default",
            "dark:!bg-general-brand-primary-darkmode",
            "!text-cta-primary-text",
            "dark:!text-text-primary-inverse-darkmode",
            "dark:hover:!text-text-primary-darkmode",
        ].join(" "), caption: [
            "flex",
            "items-center",
            "justify-between",
            "p-0",
            "text-left",
            "whitespace-nowrap",
        ].join(" "), caption_label: [
            "font-semibold",
            "text-xl",
            "peer-focus-visible:outline-dashed",
            "peer-focus-visible:outline-general-yellow-primary",
            "dark:peer-focus-visible:outline-general-yellow-primary-darkmode",
            "mr-1",
            "mb-2",
            "px-1",
        ].join(" "), dropdown: [
            "w-auto",
            "opacity-0",
            "absolute",
            "top-0",
            "right-0",
            "bottom-0",
            "left-0",
        ].join(" "), dropdown_month: "whitespace-nowrap relative", dropdown_icon: "h-4", nav: "mb-2", nav_icon: "h-1.5", nav_button_previous: navButtonClasses.join(" "), nav_button_next: navButtonClasses.join(" "), head_cell: ["pb-1", "text-md", "uppercase"].join(" "), table: "mx-auto" });
    return (_jsx("div", { className: "m-2", children: _jsx(DayPicker, { selected: value, defaultMonth: value !== null && value !== void 0 ? value : new Date(), classNames: classNames, fromYear: 1900, toYear: dayjs().year() + 100, onDayClick: onDayClick, onDayKeyDown: onDayKeyDown, initialFocus: true, components: {
                Caption,
                CaptionLabel,
                Dropdown,
                IconDropdown,
                IconLeft,
                IconRight,
            } }) }));
};
//# sourceMappingURL=Calendar.js.map